import React, { useEffect, useState } from "react";

// ASSETS

// STYLES

// LIBRARIES
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Circle, SliderItem, SliderWrapper } from "./HomeCarouselStyled";

// MISC
import { IProps } from "./HomeCarouselModel";
import { uploadBaseUrl } from "services/base";

// REDUX

// COMPONENTS
import homeService from "services/homeService";
import HeroCarouselItem from "components/HeroCarouselItem/HeroCarouselItem";

const HomeCarousel: React.FC<IProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS

  // STATE CONSTANTS
  const [currentSlide, setCurrentSlide] = useState(0);
  const [itemsData, setItemsData] = useState<any>(null);

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    // setLoading(true);
    homeService
      .getInfoCarousel()
      .then((data) => {
        // console.log("ItemsData response", data);
        setItemsData(data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, []);

  const carouselItemData = itemsData?.data
    ?.sort((a, b) => a.attributes.priority - b.attributes.priority)
    ?.map((item: any) => {
      return {
        id: item?.id,
        title: item?.attributes?.title,
        link: item?.attributes?.link,
        subtitle: item?.attributes?.subtitle,
        imgUrl: item?.attributes?.cover?.data?.attributes?.url
          ? `${uploadBaseUrl}${item.attributes.cover.data.attributes.url}`
          : null,
        external: item?.attributes?.external,
        priority: item?.attributes?.priority,
        // position: item?.attributes?.cover_position,
      };
    });

  // EVENT HANDLERS
  const settings = {
    customPaging: function (i) {
      return <Circle active={i === currentSlide} />;
    },
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    afterChange: (current) => {
      setCurrentSlide(current);
    },
  };

  return (
    <SliderWrapper>
      <Slider {...settings}>
        {carouselItemData?.map((item: any) => (
          <SliderItem key={item.id}>
            <HeroCarouselItem
              title={item.title}
              subtitle={item.subtitle}
              link={item.link}
              imgUrl={item.imgUrl}
              external={item.external}
            />
          </SliderItem>
        ))}
      </Slider>
    </SliderWrapper>
  );
};

export default HomeCarousel;
